import React from "react";
import { useCurrentFrame } from "remotion";
import { ReelMetadata } from "../../types";

interface CyberpunkHeaderProps {
  data: ReelMetadata;
  opacity: number;
  scale: number;
  translateY: number;
}

export const CyberpunkHeader: React.FC<CyberpunkHeaderProps> = ({
  data,
  opacity,
  scale,
  translateY,
}) => {
  const frame = useCurrentFrame();

  // Alternating glitch label color every 15 frames
  const labelColor = Math.floor(frame / 15) % 2 === 0 ? "#00ffe5" : "#ff003c";

  return (
    <div
      style={{
        width: "100%",
        padding: "18px 24px",
        background: "rgba(5, 0, 16, 0.9)",
        border: "1px solid #ff003c",
        boxSizing: "border-box",
        opacity,
        transform: `scale(${scale}) translateY(${translateY}px)`,
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        position: "relative",
      }}
    >
      {/* Glitch label */}
      <div
        style={{
          fontFamily: "'Share Tech Mono', monospace",
          fontSize: "11px",
          color: labelColor,
          letterSpacing: "2px",
          textTransform: "uppercase",
        }}
      >
        {"// NEURAL LINK ACTIVE //"}
      </div>

      {/* Headline container with chromatic aberration effect */}
      <div style={{ position: "relative" }}>
        {/* Red offset copy (left, behind) */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: -2,
            fontFamily: "'Rajdhani', sans-serif",
            fontSize: "30px",
            fontWeight: 700,
            color: "#ff003c",
            textTransform: "uppercase",
            letterSpacing: "2px",
            lineHeight: 1.2,
            opacity: 0.5,
            userSelect: "none",
          }}
        >
          {data.headline}
        </div>

        {/* Cyan offset copy (right, behind) */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 2,
            fontFamily: "'Rajdhani', sans-serif",
            fontSize: "30px",
            fontWeight: 700,
            color: "#00ffe5",
            textTransform: "uppercase",
            letterSpacing: "2px",
            lineHeight: 1.2,
            opacity: 0.5,
            userSelect: "none",
          }}
        >
          {data.headline}
        </div>

        {/* Main white headline on top */}
        <div
          style={{
            position: "relative",
            fontFamily: "'Rajdhani', sans-serif",
            fontSize: "30px",
            fontWeight: 700,
            color: "#f0f0f0",
            textTransform: "uppercase",
            letterSpacing: "2px",
            lineHeight: 1.2,
            zIndex: 1,
          }}
        >
          {data.headline}
        </div>
      </div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
